import { get, post, put } from "@/services/api.services";
import { PlatformDTO, SavedObject } from "../commonModels";

export type UnsavedExperimentMethod = {
    name: string;
    platform: PlatformDTO;
};

export type SavedExperimentMethod = UnsavedExperimentMethod &
    SavedObject<string> & {
        code: string;
        descriptionUrl: string | null;
    };

export type UnsavedExperimentMethodDTO = {
    name: string;
    platformId: string | null;
};

export type SavedExperimentMethodDTO = UnsavedExperimentMethodDTO &
    SavedObject<string> & {
        code: string;
    };

export const experimentMethodsAPI = {
    fetchAllExperimentMethods: async (): Promise<SavedExperimentMethod[]> => {
        return get("/experimentMethods");
    },
    createExperimentMethod: async (
        experimentMethod: UnsavedExperimentMethod
    ): Promise<SavedExperimentMethod> => {
        return post("/experimentMethods", mapExperimentMethodToDTO(experimentMethod));
    },
    updateExperimentMethod: async (
        experimentMethod: SavedExperimentMethod
    ): Promise<SavedExperimentMethod> => {
        return put(
            `/experimentMethods/${experimentMethod.id}`,
            mapExperimentMethodToDTO(experimentMethod)
        );
    },
};

function mapExperimentMethodToDTO(
    experimentMethod: UnsavedExperimentMethod | SavedExperimentMethod
): UnsavedExperimentMethodDTO | SavedExperimentMethodDTO {
    return {
        name: experimentMethod.name,
        platformId: experimentMethod.platform.id,
        ...(("id" in experimentMethod && { id: experimentMethod.id }) as object),
        ...(("code" in experimentMethod && { code: experimentMethod.code }) as object),
        ...(("descriptionUrl" in experimentMethod && {
            descriptionUrl: experimentMethod.descriptionUrl,
        }) as object),
    };
}
